module.exports = __webpack_public_path__ + "static/media/BadgeTemplates-22.5459ba37.svg";